require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.to-string");

var overArg = require('./_overArg');
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;